import { useSimpleChoicesStore } from '@/features/ChoicesLists/Simple/store';
import type {
  SimpleChoiceMetaType,
  SimpleChoiceType,
} from '@/features/ChoicesLists/Simple/types';

let simpleChoicesStore: ReturnType<typeof useSimpleChoicesStore>;

// must only be used for string / string[] metas
export const getSimpleChoiceMeta = (
  choice: SimpleChoiceType,
  field: SimpleChoiceMetaType,
  skipLoadingCheck: boolean = false,
): string[] => {
  if (simpleChoicesStore === undefined) {
    simpleChoicesStore = useSimpleChoicesStore();
  }

  if (!skipLoadingCheck && simpleChoicesStore.isLoading) {
    return [];
  }

  const meta = simpleChoicesStore.meta[choice]?.[field];

  if (typeof meta === 'string') {
    return [meta];
  }

  if (Array.isArray(meta)) {
    return meta;
  }

  return [];
};
